import { useState } from 'react';
import styled from '@emotion/styled';
import { useFloating, useHover, useInteractions } from '@floating-ui/react';
import type { KolSearchTableFilters } from '@trinity/chat-components/components/Chat/interfaces.state';

type Props = {
  activeFilters: KolSearchTableFilters.Filter[];
}

export const TableFilterTooltip = ({ activeFilters }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { context, refs, floatingStyles } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
  });

  const hover = useHover(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
  ]);

  const capitalizeStringKey = (key: string) => {
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  return (
    <>
      <Anchor ref={refs.setReference} {...getReferenceProps()}>
        <div style={{ fontWeight: '600' }}>{activeFilters.length}</div>
      </Anchor>
      {isOpen && (
        <PopperMenu
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
        >
          {activeFilters.map((filter, index) => {
            return (
              <div
                style={{ display: 'flex', alignItems: 'stretch', gap: 3, padding: 5 }}
                key={`tooltip-${filter.key}-${index}`}>
                <div style={{ fontWeight: '600' }}>
                  {capitalizeStringKey(filter.key)}
                </div>
                <div>{filter.type.split('-').join(' ')}</div>
                <div style={{ fontWeight: '600' }}>{filter.value}</div>
              </div>
            );
          })}
        </PopperMenu>
      )}
    </>
  )
}

const Anchor = styled.div({
  display: 'inline-flex',
});

const PopperMenu = styled.div(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  padding: 15,
  borderRadius: 4,
  boxShadow: `0 2px 6px 2px rgba(60, 64, 67, .15)`,
  zIndex: 4,
  minWidth: 200,
  textAlign: 'left',
}));